import script from "./BaseFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFile.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFile.vue?vue&type=style&index=0&id=0d30738c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d30738c"]])

export default __exports__